import axios from 'axios';

/**
 * Cargo parlamentar que o titular do mandato ocupa numa comissão ou na Mesa
 * Diretora: nome do órgão, função exercida e período. Ver
 * `CargoParlamentar1789150000000` (migração da API) para a decisão de
 * modelar comissão e Mesa Diretora na mesma tabela/tipo.
 */
export type TipoCargoParlamentar = 'comissao' | 'mesa_diretora';

export interface CargoParlamentarApi {
  id: string;
  tenant_id: string;
  tipo: TipoCargoParlamentar;
  nome_orgao: string;
  funcao: string;
  data_inicio: string;
  data_fim: string | null;
  created_at: string;
  updated_at: string;
}

export interface CriarCargoParlamentar {
  tipo: TipoCargoParlamentar;
  nome_orgao: string;
  funcao: string;
  data_inicio: string;
  data_fim?: string;
}

export interface AtualizarCargoParlamentar {
  tipo?: TipoCargoParlamentar;
  nome_orgao?: string;
  funcao?: string;
  data_inicio?: string;
  data_fim?: string | null;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const cargosParlamentaresApi = {
  list: async (token: string) => {
    const res = await axios.get<CargoParlamentarApi[]>(
      `${API_URL}/core/cargos-parlamentares`,
      auth(token),
    );
    return res.data;
  },

  create: async (data: CriarCargoParlamentar, token: string) => {
    const res = await axios.post<CargoParlamentarApi>(
      `${API_URL}/core/cargos-parlamentares`,
      data,
      auth(token),
    );
    return res.data;
  },

  update: async (id: string, data: AtualizarCargoParlamentar, token: string) => {
    const res = await axios.put<CargoParlamentarApi>(
      `${API_URL}/core/cargos-parlamentares/${id}`,
      data,
      auth(token),
    );
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/core/cargos-parlamentares/${id}`, auth(token));
  },
};
